var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',_vm._b({attrs:{"dense":"","text":"","type":_vm.type}},'v-alert',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }